import { TOGGLE_DETAILED_BROWSER_LOGGING } from 'config/toggles';

/* eslint-disable no-console */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
const debug = (message: any, ...optionalParams: any[]) => {
  if (TOGGLE_DETAILED_BROWSER_LOGGING) console.debug(message, ...optionalParams);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
const log = (message: any, ...optionalParams: any[]) => {
  if (TOGGLE_DETAILED_BROWSER_LOGGING) console.log(message, ...optionalParams);
};

// error logs are always shown in users' console in case Support needs more info from them, etc.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
const error = (message: any, ...optionalParams: any[]) => {
  console.error(message, ...optionalParams);
};

const wconsole = { debug, log, error };

export default wconsole;
